import { useNavigate, useParams } from 'react-router-dom';
import { CollectionView } from '@/app/pages/helpcenter/HelpcenterCollectionView';
import { useFaqData } from '@/context/faq-data.provider';

export function CollectionRouteWrapper() {
  const { collectionSlug } = useParams();
  const { collections } = useFaqData();
  const navigate = useNavigate();

  const collection = collections.find((col) => col.slug === collectionSlug);

  if (!collection) {
    navigate('/not-found', { replace: true });
    return null;
  }
  return <CollectionView data={collection} />;
}
